<template>
  <div id="back-play">
    <!-- 头 -->
    <div class="top">
      <div class="go_back cursor" @click="go_back()"></div>
      <p>
        {{ playbackData.title }} {{ playbackData.begin_time.split(' ')[0] }}
      </p>
      <img
        class="cursor"
        ondragstart="return false;"
        @click.stop="toggoleProtect(true)"
        :src="
          openEye
            ? 'static/img/playback/eye_open.png'
            : 'static/img/playback/eye_close.png'
        "
      />
    </div>
    <div class="video_box" @click="clickVideo">
      <div
        class="play_video"
        :style="{ width: videoWH.w + 'px', height: videoWH.h + 'px' }"
      >
        <i
          class="close_question cursor"
          v-show="closeQuestionShow"
          @click="closeQuestion"
        ></i>
        <kejian
          @closeIframe="closeQuestion"
          @loadGameSuccess="loadGameSuccess = true"
          :subType="kejianQuestionSubType"
          :type="kejianQuestionType"
          :iframeQuickId="iframeQuickId"
          @countDown="showClock"
          :gameName="gameName"
          :questionids="questionids"
          :topicType="2"
          ref="kejian"
          @click.native="clickVideo"
          :preClassTestBgImage="preClassTestBgImage"
        />
        <!--        :src="playbackData.play_back_url"-->
        <video
          crossOrigin="anonymous"
          v-if="videoShow"
          class="video"
          :src="playbackData.play_back_url"
          :width="videoWH.w"
          :height="videoWH.h"
          id="video"
          ref="video"
          @ended="playend"
          @contextmenu.prevent
        ></video>
      </div>
    </div>
    <div
      class="bottom"
      @mouseenter="bottomShow = true"
      @mousemove="bottomShowFn"
      @mouseleave="bottomShow = false"
    >
      <transition name="fade">
        <div
          class="bottom_sub"
          v-show="bottomShow && questionEndTime === -1"
          @click.stop
        >
          <div class="bottom_cont">
            <img
              class="play-toggle cursor"
              @click="togglePlay"
              :src="
                playFlag
                  ? '/static/img/playback/play.png'
                  : '/static/img/playback/pause.png'
              "
              alt
            />
            <span class="video-currentTime">{{ currentTime | time }}</span>
            <div class="input_box">
              <i
                class="cursor"
                :class="{ i_active: currentTime >= Number(v.time) }"
                v-for="(v, i) in playbackData.playback_url_tag"
                :key="i"
                :style="{
                  left: 'calc(' + (v.time / duration || 0) * 100 + '% + 6px)',
                }"
              >
                <em>
                  {{ v.tag }}
                  <img
                    @click="clickVideoTag({ v, i })"
                    src="../../../assets/img/common/play.png"
                  />
                </em>
              </i>
              <input
                class="range"
                type="range"
                @change="range"
                @mousedown="rangeMousedown"
                @mouseup="rangeMouseup"
                v-model="currentTime"
                :max="duration"
                ref="range"
                min="0"
                step="1"
                :style="{
                  backgroundSize:
                    (currentTime / duration || 0) * 100 + '% 100%',
                }"
              />
            </div>
            <span class="video-duration">{{ duration | time }}</span>
            <span class="rate cursor" @click="clickTagSwitch(3)">{{
              `${rateArr[rateIndex]}X`
            }}</span>
            <img
              v-if="!issafariBrowser"
              class="screenshots cursor"
              src="static/img/playback/screenshots.png"
              @click="screenshots()"
              alt
            />
            <img
              class="vp-tap cursor"
              src="/static/img/playback/tagList.png"
              @click="clickTagSwitch(2)"
              alt
            />
          </div>
        </div>
      </transition>
    </div>
    <transition :name="timu_message.type === 'xuanze' ? 'xz' : 'tk'">
      <answer
        :value="value"
        v-show="a_on_off"
        :a_on_off="a_on_off"
        :datas="timu_message"
        @dati_xz="dati_xz"
        :k_on_off="k_on_off"
        @dati_tk="dati_tk"
        @sure="sure"
        @txt_sure="txt_sure"
      />
    </transition>
    <!-- 倒计时 -->
    <transition name="countDown">
      <countDown
        v-if="time_on_off"
        :countDownVal="countDownVal"
        @closeClock="closeQuestion"
      />
    </transition>
    <!-- 键盘区域 -->
    <keyboard
      :input_type="Keyboard_type"
      v-show="k_on_off"
      v-on:changeinput="changeinput"
      ref="keyboard"
      @sure="sure"
    />
    <slide
      :showExeriseList="showExeriseList"
      :tagIndex="tagIndex"
      @clickVideoTag="clickVideoTag"
      @changeRate="changeRate"
      @clickTagSwitch="clickTagSwitch"
      :rateIndex="rateIndex"
      :rateArr="rateArr"
      :playbackData="playbackData"
    ></slide>
    <!-- loading -->
    <loading v-show="loadState === 'loading'" />
    <loaderr
      v-show="loadState === 'loaderr'"
      @loadvideo="loadAgain"
      loadErrText="加载失败，请点击按钮重新加载~"
    />
    <!-- 设备错误 -->
    <alert
      :show="showAlert"
      :sameOne="'您的设备播放课程回放出现异常请联系学管老师'"
      :cancal="'我知道了'"
      @cancelEvent="showAlert = false"
    />
    <Toast
      :showText="showText"
      :waitTime="3000"
      v-if="showText"
      @toastCallBack="showText = ''"
    />
    <Tips v-if="answerTipsShow" @close="answerTipsShow = false"></Tips>
    <!-- 你真棒动画 -->
    <motivate
      :answerResults="answerResults"
      :answerAdd="answerAdd"
      v-if="answerResults"
      @animEnd="onLottieEnd"
    />
    <!--    <continuous-->
    <!--      :continuousData="continuousData"-->
    <!--      @animEnd="continuousData = {}"-->
    <!--      v-if="continuousData.level"-->
    <!--    />-->
  </div>
</template>
<script>
import Hls from 'hls.js';
import common from 'common';
import alert from '@/components/basic/alert.vue';
import utils from '@/js/utils.js';
import { mapState, mapActions, mapMutations } from 'vuex';
import Toast from '../../basic/toast'; //Toast
import Tips from './tips.vue';
import slide from './slide.vue';
import loading from '@/components/basic/videoloading';
import loaderr from '../video/loaderr.vue'; //视频加载失败
import answerJs from '../video/answer/answer.js';
import answer from '../video/answer/answer.vue';
import kejian from '../video/answer/kejian.vue';
import motivate from '../video/motivate.vue';
import continuous from '../video/continuous.vue';
import lottie from 'lottie-web-limi';
import Keyboard from '../video/keyboard.vue';
import countDown from '../video/countDown.vue';
export default {
  name: 'playback',
  mixins: [answerJs],
  data() {
    return {
      videoWH: utils.setVideoWH(96),
      video: null,
      showExeriseList: 1, //展开练习列表，
      tagIndex: -1, //当前播放到位置信息
      showAlert: false, //超时提示框
      loadState: 'loading', //是否显示Loading
      isShowSidebarMask: false, //练习列表展示的时候是否要在视频区域显示蒙层
      bottomShow: true,
      videoShow: true,
      videoLoad: true, //视频第一次加载
      bottomInterval: null,
      playFlag: false, //是否正在播放
      duration: 0, //视频总长
      currentTime: 0, //视频当前时间
      isDrag: false,
      openEye: false,
      timer: null,
      rateIndex: 3,
      rateArr: ['2.0', '1.5', '1.25', '1.0', '0.8'],
      temp_unique_id: Date.now(),
      issafariBrowser: utils.issafariBrowser(),
      onlineTime: 0,
      showText: '',
      loadInterval: null, //十秒加载失败计时器
      sendLogData: {}, //发题日志
      answerTipsShow: false, //答题提示
      questionEndTime: -1, //题目关闭时间
      questionStartTime: -1, //题目开始展示时间
      currentKey: -1,
      sendTestInterval: null, //定时发送课前测计时器
      closeQuestionShow: false, //关闭题目按钮是否展示
      hlsObj: null,
      answerResults: '',
      answerAdd: {},
      questionRight: -1,
      imageResources: '',
      k_on_off: false,
      value: undefined, //键盘未填空题时中间区域价盘输入内容和填空题中间区域的绑定
      time_on_off: false, //倒计时是否显示
      countDownVal: 15, //倒计时时间
      voiceIsStop: false, //语音题是否录音结束
    };
  },
  components: {
    countDown,
    Keyboard,
    continuous,
    motivate,
    loading,
    alert,
    Toast,
    slide,
    loaderr,
    answer,
    kejian,
    Tips,
  },
  mounted() {
    const eyeMode =
      LIMI_ENV === 'electron'
        ? utils.getNodeStorge('eyeMode')
        : common.get('eyeMode');
    if (eyeMode) {
      this.toggoleProtect(false);
    }
    this.getLog();
    this.bottomShowFn();
    this.uploadOnlineTime();
    this.initVideo();
    this.eventHub();
    setTimeout(() => {
      if (sessionStorage.getItem('errorTime')) {
        console.log(305);
        this.playChapter(parseInt(sessionStorage.getItem('errorTime')));
        sessionStorage.removeItem('errorTime');
      }
    }, 500);
  },
  computed: {
    ...mapState([
      'playbackData',
      'video_replay_time',
      'smallClassId',
      'count_online_time_interval',
      'lesson_type',
      'lesson_id',
      'class_id',
      'userID',
      'playbackQuestionTime',
      'video_stream_load_timeout',
      'continuousRightConfig',
      'danmuStyleList',
      'myDanmuStyleId',
      'continuousLevel',
      'lessonState',
      'giftSwitchUniqueId',
      'isSlave',
      'rankRandTimeForClient',
      'userHeadwear',
      'isContinuousRightSetting',
      'barragePosition',
      'smallClassType',
      'class_type',
      'fakeLive',
    ]),
    //起始的播放时间：如果有节点，直接跳过开始的那个段时间
    videoBegin() {
      return this.playbackData.playback_url_tag[0]
        ? this.playbackData.playback_url_tag[0]
        : {};
    },
    //每个节点对应的播放时间段
    videoTagTimeArr() {
      let temp = this.playbackData.playback_url_tag;
      let time_length = this.playbackData.time_length;
      let arr = [];
      if (!!temp) {
        arr = temp.map((v) => v.time);
        arr.push(time_length);
      }
      return arr;
    },
  },
  methods: {
    ...mapActions(['durationRport', 'getPlaybackSendLog', 'getImageResources']),
    ...mapMutations(['savePlaybackData']),
    initVideo() {
      if (
        Hls.isSupported() &&
        this.playbackData.play_back_url.includes('.m3u8')
      ) {
        this.video = this.$refs.video;
        if (!this.video) return;
        this.hlsObj = new Hls();
        this.hlsObj.attachMedia(this.video);

        if (this.hlsObj) {
          this.hlsObj.loadSource(this.playbackData.play_back_url);
          this.hlsObj.on(Hls.Events.MANIFEST_PARSED, () => {
            window.onresize = () => {
              this.videoWH = utils.setVideoWH(96);
            };
            this.loadInterval = setTimeout(
              this.videoError,
              this.video_stream_load_timeout * 1000,
            );
            this.video.oncanplay = () => {
              if (!this.videoLoad) return;
              this.videoLoad = false;
              let durationTime = parseInt(this.video.duration);
              let srvTime = parseInt(this.playbackData.time_length);
              let videotime = Math.abs(srvTime - durationTime);
              this.loadState = '';
              clearTimeout(this.loadInterval);
              if (
                this.video_replay_time != 0 &&
                videotime >= this.video_replay_time
              ) {
                this.showAlert = true;
                this.videoShow = false;
                this.video = null;
                return;
              }
              this.playChapter(this.videoBegin.time);
              this.duration = this.video.duration;
            };
            this.video.addEventListener('timeupdate', this.videoTimeupdate);
            this.video.addEventListener('error', this.videoError);
            this.video.addEventListener('waiting', this.videoWaiting);
          });
        }
      } else {
        this.video = this.$refs.video;
        if (!this.video) return;
        window.onresize = () => {
          this.videoWH = utils.setVideoWH(96);
        };
        this.loadInterval = setTimeout(
          this.videoError,
          this.video_stream_load_timeout * 1000,
        );
        this.video.oncanplay = () => {
          if (!this.videoLoad) return;
          this.videoLoad = false;
          let durationTime = parseInt(this.video.duration);
          let srvTime = parseInt(this.playbackData.time_length);
          let videotime = Math.abs(srvTime - durationTime);
          this.loadState = '';
          clearTimeout(this.loadInterval);
          if (
            this.video_replay_time != 0 &&
            videotime >= this.video_replay_time
          ) {
            this.showAlert = true;
            this.videoShow = false;
            this.video = null;
            return;
          }
          this.playChapter(this.videoBegin.time);
          this.duration = this.video.duration;
        };
        this.video.addEventListener('timeupdate', this.videoTimeupdate);
        this.video.addEventListener('error', this.videoError);
        this.video.addEventListener('waiting', this.videoWaiting);
      }
    },
    playend() {
      this.video.currentTime = this.duration;
      this.video.pause();
      this.playFlag = false;
      console.log(446);
      this.closeQuestion();
    },
    videoTimeupdate() {
      //使用事件监听方式捕捉事件
      const timeDisplay = Math.floor(this.video.currentTime);
      if (this.currentTime != timeDisplay) {
        this.loadState = '';
      }
      if (
        (timeDisplay >= this.questionEndTime ||
          timeDisplay < this.questionStartTime) &&
        this.questionEndTime !== -1
      ) {
        //
        console.log(461);
        clearInterval(this.sendTestInterval);
        // this.closeQuestion();
      }
      if (
        this.currentTime == timeDisplay &&
        this.currentKey == this.currentTime
      )
        return;
      if (!this.isDrag) {
        this.currentTime = timeDisplay;
        this.uploadEffectiveOnlineTime();
      }
      if (this.sendLogData[this.currentTime - 1] && !this.isDrag) {
        // console.log('展示题目时间',this.currentTime)
        clearInterval(this.sendTestInterval);
        this.currentKey = this.currentTime;
        this.showQuestion(this.currentTime);
      } else {
        this.currentKey = -1; //为了解决第一次播放时间点有题不展示问题
      }
      this.tagListChecked(timeDisplay);
    },
    videoWaiting() {
      // console.log('卡顿------')
      this.loadState = 'loading';
    },
    videoError() {
      this.loadState = 'loaderr';
      this.video && this.video.pause();
      this.playFlag = false;
      sessionStorage.setItem('errorTime', this.video.currentTime + 1);
      location.reload();
    },
    //选择题按键点击
    dati_xz(data) {
      console.log(467, data);
      if (!this.a_on_off) return;
      setTimeout(() => {
        this.closeQuestion();
      }, 600);
      this.$root.eventHub.$emit('playbackQuestion', data);
    },
    //填空题中间区域点击
    dati_tk(k_on_off) {
      this.k_on_off = k_on_off;
    },
    //填空题确认按钮
    sure(data) {
      console.log(495, data);
      this.closeQuestion();
      console.log(497, data);
      if (data.answer.replace(/[#|@|\*|\/]/gi, '') == '') return;
      console.log(499);
      this.$root.eventHub.$emit('playbackQuestion', data);
      console.log(501);
    },
    txt_sure(data) {
      this.closeQuestion();
      if (data.answer.trim() == '') return;
      this.$root.eventHub.$emit('playbackQuestion', data);
    },
    closeQuestion(origin) {
      //课前测主动关闭类型
      if (
        (origin == 'countDown' || origin == 'closequestion') &&
        this.quickData[this.iframeQuickId] &&
        this.quickData[this.iframeQuickId].type == 5
      ) {
        this.timeOver = true;
        return;
      }
      if (this.voiceIsStop) {
        this.time_on_off = false; //倒计时
        this.voiceIsStop = false;
        return;
      }
      if (
        (origin == 'countDown' || origin == 'closequestion') &&
        this.$refs.kejian.closeTimeout > 0
      ) {
        this.time_on_off = false; //倒计时
        this.$refs.kejian.closeTimeout = 0;
        return;
      }
      this.answerTipsShow = false;
      this.a_on_off = false;
      this.k_on_off = false;
      this.time_on_off = false
      this.timu_message = {};
      this.iframeQuickId = ''; //课件题
      this.gameName = ''; //小游戏
      this.loadGameSuccess = false; //小游戏加载成功标记
      this.questionids = '';
      this.questionEndTime = -1;
      this.questionStartTime = -1;
      this.closeQuestionShow = false;
      this.removeTestData();
    },
    //删除课前测缓存数据
    removeTestData() {
      const frontTest = common.get('frontTest') || [];
      frontTest.forEach((v, i) => {
        if (v.lesson_id == this.lesson_id) {
          frontTest.splice(i, 1);
        }
      });
      common.set('frontTest', frontTest);
    },
    //答题区域显示隐藏的方法
    showQuestion(ctime) {
      console.log(453, '摊提iii');
      const key = ctime - 1;
      const type = this.sendLogData[key].qtype;
      const qid = this.sendLogData[key].quickQuestionId;
      const datas = {
        unique_id: ' ',
        data: {
          quick_question_id: qid,
          type: type,
          srv_time: common.getTemServerTime(),
        },
      };
      let len = 1;
      if (type == 5 && this.quickData[qid]) {
        let arr = this.quickData[qid].question_ids.split(',');
        len = arr.length;
        this.sendTestInterval = setInterval(() => {
          arr.shift();
          if (arr.length === 0) {
            clearInterval(this.sendTestInterval);
            return;
          }
          const frontTest = common.get('frontTest');
          const index = frontTest.findIndex((v) => {
            return v.qid == this.currentQuestion;
          });
          const index1 = frontTest[index].qdata.findIndex((v) => {
            return v.qid == arr[0];
          });
          frontTest[index].qdata[index1 - 1].status = 1;
          common.set('frontTest', frontTest);
          this.$root.eventHub.$emit('autoTurnPage', { id: qid });
        }, (this.playbackQuestionTime / this.rateArr[this.rateIndex]) * 1000);
      }
      this.$root.eventHub.$emit('question', datas, '');
      this.showExeriseList = 1;
      this.bottomShow = false;
      this.questionEndTime = ctime + this.playbackQuestionTime * len;
      this.questionStartTime = ctime;
      setTimeout(() => {
        if (this.quickData[qid] || this.standardData[qid])
          this.closeQuestionShow = true;
      }, 1200);
    },
    tagListChecked(timeDisplay) {
      let tagArr = this.videoTagTimeArr;
      let len = tagArr.length;
      if (len) {
        tagArr.forEach((v, i, s) => {
          if (timeDisplay >= v) {
            this.tagIndex = i;
          }
          if (i === 0 && timeDisplay < v) {
            this.tagIndex = -1;
          }
          if (i === len - 1 && timeDisplay > s[len - 2]) {
            this.tagIndex = len - 2;
          }
        });
      }
    },
    //从新加载视频
    loadAgain() {
      this.loadState = 'loading';
      this.videoFirstLoad = true;
      this.video && this.video.load();
      this.togglePlay();
      this.loadInterval = setTimeout(
        this.videoError,
        this.video_stream_load_timeout * 1000,
      );
    },
    range() {
      this.playChapter(this.currentTime);
      this.bottomShow = false;
    },
    rangeMousedown() {
      clearTimeout(this.bottomInterval);
      this.isDrag = true;
    },
    rangeMouseup() {
      this.isDrag = false;
    },
    bottomShowFn() {
      clearTimeout(this.bottomInterval);
      if (this.bottomShow && !this.isDrag) {
        this.bottomInterval = setTimeout(() => {
          this.bottomShow = false;
        }, 5000);
      }
    },
    //=>切换视频播放暂停
    togglePlay() {
      if (this.video.paused) {
        if (this.currentTime >= Math.floor(this.duration)) {
          this.video.currentTime = 0;
        }
        this.video.play();
        this.playFlag = true;
        this.bottomShow = false;
        return;
      }
      this.playFlag = false;
      this.video.pause();
    },
    //根据时间切换视频播放
    playChapter(time = 0) {
      this.video.currentTime = time;
      this.video.play();
      this.playFlag = !this.video.paused;
    },
    destroyVideo() {
      clearInterval(this.timer);
      clearInterval(this.sendTestInterval);
      clearTimeout(this.loadInterval);
      this.timer = null;
      this.sendTestInterval = null;
      this.loadInterval = null;
      if (this.hlsObj) {
        this.hlsObj.destroy();
        this.hlsObj = null;
      }
      const video = this.video || this.$refs.video;
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
        video.removeEventListener('timeupdate', this.videoTimeupdate);
        video.removeEventListener('error', this.videoError);
        video.removeEventListener('waiting', this.videoWaiting);
      }
      this.video = null;
      this.playFlag = false;
    },
    //点击返回上一级
    go_back() {
      this.closeQuestion();
      this.destroyVideo();
      this.offEventHub();
      this.$router.push({
        name: 'course',
      });
    },
    //显示隐藏题目列表
    clickTagSwitch(type) {
      this.showExeriseList = type;
    },
    //点击题目切换到对应的题目讲解
    clickVideoTag({ v, i }) {
      this.tagIndex = i;
      this.playChapter(v.time);
      this.clickTagSwitch(1);
      this.bottomShow = false;
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventPlayBackTag',
        data: {
          name: v.tag,
          index: i + 1,
        },
      });
    },
    //更改倍速
    changeRate({ v, i }) {
      this.video.playbackRate = v;
      this.rateIndex = i;
      this.clickTagSwitch(1);
    },
    //点击mask隐藏视频分段列表和mask
    clickVideo() {
      // console.log(596,'==========')
      // if (this.questionStartTime !== -1) {
      //   this.answerTipsShow = true;
      //   return;
      // }
      // this.showExeriseList = 1;
    },
    //截图
    screenshots() {
      this.bottomShow = false;
      this.showText = '';
      if (LIMI_ENV === 'electron') {
        utils.screenshotsPc((res) => {
          if (res === 'success') {
            this.showText = '截图已保存到桌面';
            this.$root.eventHub.$emit('createLog', {
              id: 'LMTrackEventScreeCapture',
              data: {
                pageType: 2,
              },
            });
          }
        });
      } else {
        utils.downloadScreenshotsWeb();
        this.$root.eventHub.$emit('createLog', {
          id: 'LMTrackEventScreeCapture',
          data: {
            pageType: 2,
          },
        });
      }
    },
    toggoleProtect(needToast) {
      this.openEye = !this.openEye;
      this.$root.eventHub.$emit('toggoleProtect', {
        openEye: this.openEye,
        needToast,
      });
    },
    //大数据埋点上报
    uploadOnlineTime() {
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventVideoPage_start',
        data: {
          lesson_type: this.playbackData.lesson_type,
          unique_id: this.temp_unique_id,
          small_class_id: this.smallClassId,
        },
      });
      let that = this;
      //上报观看回放时间
      this.timer = setInterval(() => {
        const duration = this.video ? that.video.currentTime : 0;

        !this.video.paused &&
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventViewingTime',
            data: {
              lesson_type: this.playbackData.lesson_type,
              unit: this.count_online_time_interval,
              isPlayback: 1,
            },
            duration,
          });
      }, 1000 * this.count_online_time_interval);
    },
    //上报有效的观看回放
    uploadEffectiveOnlineTime() {
      this.onlineTime++;
      if (
        this.onlineTime >= this.count_online_time_interval &&
        document.visibilityState === 'visible'
      ) {
        this.onlineTime = 0;
        let type = 2;
        if (this.lesson_type == 1 || this.lesson_type == 5) {
          type = 3;
        }
        if (this.lesson_type == 3 || this.lesson_type == 6) {
          type = 2;
        }
        const sendData = {
          time: common.getTemServerTime(),
          event: 2001,
          data: {
            class_id: this.class_id,
            lesson_id: this.lesson_id,
            student_id: this.userID,
            type: type,
            length: this.currentTime,
          },
        };

        this.durationRport(sendData);
      }
    },
    //获取发题日志
    getLog() {
      this.getPlaybackSendLog({
        lessonId: this.lesson_id,
      }).then(({ res, ok }) => {
        if (ok) {
          this.sendLogData = res;
        }
      });
    },
    //判断题目答对答错
    questionRightFn(datas) {
      const type = datas.data.question_type,
        right = datas.data.right,
        rightNum = datas.data.answer_continuous,
        coin = datas.data.coin,
        teamScore = datas.data.student_score;

      //right 0错误  1正确
      let animationType = right == 1 ? 'normalRight' : 'normalError';
      // if (type == 3 || type == 4) {
      //   const dom = this.$refs.kejian || '';
      //   this.questionRight = right;
      //   animationType = right == 1 ? dom.rightAnimation : dom.wrongAnimation;
      // }
      this.answerResults = animationType;
    },
    onLottieEnd() {
      this.questionRight = -1;
      this.answerResults = '';
    },
    offEventHub() {
      this.$root.eventHub.$off('danmu');
    },
    eventHub() {
      this.offEventHub();
      //弹幕
      this.$root.eventHub.$on('danmu', (datas) => {
        console.log(734, datas);
        if (datas.data.from_uid == this.userID) {
          if (datas.data.msg_type == 1 && datas.data.msg_body.type == 4) return;
          //console.log("消息结果",datas)
          if (
            (datas.data.question_type == 2 ||
              (datas.data.isCorrectAnswer == 1 &&
                datas.data.question_type == 6) ||
              datas.data.question_type == 3 ||
              datas.data.question_type == 4) &&
            datas.data.quick_question_id == this.currentQuestion
          ) {
            this.answerAdd = {
              coin: datas.data.coin,
              teamScore: datas.data.student_score,
              rightAnswer: this.Format(datas.data.right_answer),
              answer: this.Format(datas.data.answer),
              type: datas.data.question_type,
            };
            if (datas.data.voice) {
              this.voiceEvalData = datas.data.voice;
              this.voiceEvalData.coin = datas.data.coin;
              this.voiceEvalData.teamScore = datas.data.student_score;
            } else {
              this.questionRightFn(datas);
            }
            // this.upDateContinuousLevel({
            //   continuousNum: datas.data.answer_continuous,
            //   continuousLevel: datas.data.answer_level,
            // });
          }

          //收到自己弹幕埋点
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventDanmuReceive',
            data: {
              unque_id: datas.unique_id,
              type: datas.data.msg_type,
              answer: datas.data.answer || '',
              coin: Number(datas.data.coin) || '',
            },
          });
        }
        // this.formatDamuMessge(datas.data, datas.unique_id);
      });
    },
    //弹幕消息格式化方法
    formatDamuMessge(data, unique_id) {
      let questionType = data.question_type;
      let msgType = data.msg_type;
      let uid = data.from_uid;
      let name = data.from_nickname;
      let msgBody = data.msg_body;
      let isRight = data.right;
      let answer = data.answer;
      //type:0 个人文字答案弹幕 1 个人分数弹幕 2 个人根号弹幕  3 个人平方弹幕  4 普通文字弹幕  5 其他人弹幕 6表情弹幕 7文字弹幕
      let isOwn = uid == this.userID;
      let isstandard =
        data.isCorrectAnswer == 1
          ? false
          : questionType == 1 || questionType == 6;
      let answer_level = this.continuousRightConfig[data.answer_level] || {};
      let danmuStyleData = this.danmuStyleList[data.text_effect] || {};
      const directory = answer_level.directory;
      const level = answer_level.level;
      const cUpdateTime = this.imageResources.continuousRightConfig
        ? this.imageResources.continuousRightConfig.updateTime
        : 0;
      const levelUrl = `${this.continuousRightBaseUrl}${directory}${level}/${level}.png?v=${cUpdateTime}`;
      let obj = {
        isOwn,
        name,
        unique_id,
        isstandard,
        isRight: isRight == 1,
        isQuestion: msgType != 1,
        txtColor: danmuStyleData.color || '',
        bgColor: answer_level.barrageColor,
        levelUrl: answer_level.level && this.conAnimShow ? levelUrl : '',
        continuousNum: this.conAnimShow ? data.answer_continuous || 0 : 0,
        gradient:
          danmuStyleData.colorList && danmuStyleData.colorList.length > 1
            ? `linear-gradient(180deg,${danmuStyleData.colorList.join(',')})`
            : null,
        // gradient: `linear-gradient(180deg, red, blue)`
      };
      if (msgType == 1) {
        if (msgBody.type == 2) {
          obj = Object.assign(obj, {
            type: 6,
            value: this.imgBaseUrl + msgBody.img,
          });
        } else {
          if (msgBody.type == 4) {
            obj = Object.assign(obj, {
              type: 7,
              isRight: true,
              isstandard: true,
              value: [msgBody.text],
            });
          } else {
            obj = Object.assign(obj, {
              type: 4,
              isRight: true,
              imgSrc: msgBody.text_img
                ? this.imgBaseUrl + msgBody.text_img
                : '',
              value: [msgBody.text],
            });
          }
        }
      } else if (msgType == 5) {
        //表扬
        obj = Object.assign(obj, {
          type: 8,
          isRight: true,
          isstandard: true,
          value: [msgBody.pre_text_title, msgBody.text_title, msgBody.text],
        });
      } else if (msgType == 6) {
        //发礼物
        obj = Object.assign(obj, {
          type: 9,
          isRight: true,
          isstandard: true,
          imgurl: msgBody.baseUrl + msgBody.imageUrl,
          value: [msgBody.text],
        });
      } else if (data.sub_type === 'G13' || data.sub_type === 'G23') {
        //发礼物
        obj = Object.assign(obj, {
          type: 4,
          isRight: true,
          value: [answer],
        });
      } else {
        if (isOwn) {
          if (questionType == 6 && data.qtype == 3) {
            obj = Object.assign(obj, {
              type: 7,
              isRight: true,
              isstandard: true,
              value: [answer],
            });
          } else {
            let data = this.Format(answer, true);
            obj = Object.assign(obj, {
              type: data.type,
              value: data.value,
            });
          }
        } else if (data.isPublicAnswer == 1) {
          let data = this.Format(answer, true);
          obj = Object.assign(obj, {
            type: data.type,
            value: data.value,
          });
        } else {
          obj = Object.assign(obj, {
            type: 5,
            value: ['***'],
          });
        }
      }
      if (this.danmuList.length >= 30) {
        this.danmuList = [...this.danmuList.slice(-30)];
      }
      this.danmuList.push(obj);
      if (this.govideo) {
        top.postMessage({ type: 'danmu', data: this.danmuList }, '*');
      }
    },
    animInit(url) {
      let anim = lottie.loadAnimation({
        container: document.querySelector('.cache'), // the dom element that will contain the animation
        renderer: 'svg', //svg,canvas
        loop: false,
        autoplay: false,
        path: url,
      });
      anim.addEventListener('DOMLoaded', () => {
        anim.removeEventListener('DOMLoaded');
        anim.destroy();
        anim = null;
      });
    },
    getCatchVideoResources() {
      let catchData =
        LIMI_ENV === 'electron'
          ? utils.getNodeStorge('videoResources')
          : common.get('videoResources');
      if (!catchData) return {};
      let res = {};
      for (const key in catchData) {
        if (!key.includes('barrage_') && !key.includes('textList_')) {
          res[key] = catchData[key];
        }
      }
      res.barrage = catchData[`barrage_${this.subject}`] || {};
      res.textList = catchData[`textList_${this.subject}`] || {};
      return res;
    },
    setCatchVideoResources(res) {
      let catchData =
        (LIMI_ENV === 'electron'
          ? utils.getNodeStorge('videoResources')
          : common.get('videoResources')) || {};
      for (const key in res) {
        if (key === 'barrage' || key === 'textList') {
          catchData[`${key}_${this.subject}`] = res[key];
        } else {
          catchData[key] = res[key];
        }
      }
      if (LIMI_ENV === 'electron') {
        utils.setNodeStorge('videoResources', catchData);
      } else {
        common.set('videoResources', catchData);
      }
    },
    //键盘输入内容时更新正在输入的内容
    changeinput(data) {
      this.value = data;
      console.log(1034, data);
    },
    showClock(time = 0) {
      console.log('1048==================');
      if (time === 0 || time === '0') return;
      this.time_on_off = true;
      this.countDownVal = time * 1;
    },
  },
  watch: {
    bottomShow() {
      this.bottomShowFn();
    },
  },
  destroyed() {
    this.destroyVideo();
    this.removeTestData();
    this.offEventHub();
    window.onresize = null;
    this.$root.eventHub.$emit('createLog', {
      id: 'LMTrackEventVideoPage_end',
      data: {
        lesson_type: this.playbackData.lesson_type,
        unique_id: this.temp_unique_id,
        small_class_id: this.smallClassId,
      },
    });
    this.savePlaybackData({});
  },
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
#back-play {
  text-align: center;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  background: #000000;
  overflow: hidden;
}
.top {
  position: relative;
  z-index: 99;
  height: 96px;
  width: 100%;
  background: #000000;
  text-align: center;
  p {
    font-size: 31px;
    color: #ffffff;
    line-height: 96px;
    text-shadow: 0 0 12px rgba(0, 0, 0, 0.5);
    font-family: PingFang_Medium;
  }
  .go_back {
    position: absolute;
    height: 56px;
    width: 56px;
    left: 30px;
    top: 20px;
    background: url(../../../assets/img/common/back.png) left center no-repeat;
    background-size: 100% 100%;
    z-index: 3;
  }
  img {
    position: absolute;
    width: 56px;
    height: 56px;
    right: 30px;
    top: 21px;
  }
}
.video_box {
  width: 100%;
  height: calc(100% - 96px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.play_video {
  position: relative;
}
.close_question {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 99;
  width: 90px;
  height: 36px;
  background: url('/static/img/playback/close_question.png') no-repeat;
  background-size: cover;
}
.bottom {
  width: 100%;
  height: 96px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 99;
}
.bottom_sub {
  width: 100%;
  height: 96px;
  background: #000000;
  .bottom_cont {
    width: 100%;
    display: flex;
    height: 40px;
    padding-top: 20px;
    align-items: center;
  }
  .play-toggle {
    float: left;
    margin: 5px 0 0 27px;
    text-align: left;
    width: 20px;
    height: 23px;
    margin-top: -5px;
  }
  .input_box {
    flex: 1;
    margin: 0 40px 0 15px;
    position: relative;
    i {
      width: 6px;
      height: 6px;
      background: #ffffff;
      border-radius: 50%;
      position: absolute;
      box-sizing: content-box;
      top: 9px;
      left: 0;
    }
    i:hover {
      width: 8px;
      height: 8px;
      top: 8px;
      em {
        display: inherit;
      }
    }
    .i_active {
      border: 1px solid #007a9c;
    }
    em {
      position: fixed;
      max-width: 166px;
      min-width: 76px;
      height: auto;
      text-align: left;
      background: #008acf;
      border-radius: 9px;
      color: #ffffff;
      font-size: 18px;
      padding: 15px 20px;
      margin-top: -24px;
      margin-left: 4px;
      transform: translate(-50%, -100%);
      word-break: break-all;
      display: none;
      &::after {
        content: '';
        position: absolute;
        width: 0px;
        height: 0;
        left: 50%;
        margin-left: -8px;
        border: 8px solid #008acf;
        border-left: 8px solid transparent;
        border-top: 8px solid transparent;
        border-bottom-right-radius: 5px;
        transform: rotate(45deg);
        bottom: -7px;
      }
      &::before {
        content: '';
        position: absolute;
        width: 20px;
        height: 30px;
        left: 50%;
        margin-left: -10px;
        bottom: -27px;
      }
      img {
        width: 40px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin: -20px 0 0 -20px;
      }
    }
  }
  .range {
    width: calc(100% + 22px);
    outline: none;
    -webkit-appearance: none; /*清除系统默认样式*/
    background: -webkit-linear-gradient(#008acf, #008acf) no-repeat, #333;
    background: -o-linear-gradient(#008acf, #008acf) no-repeat, #333;
    background: -moz-linear-gradient(#008acf, #008acf) no-repeat, #333;
    background: linear-gradient(#008acf, #008acf) no-repeat, #333;
    height: 3px; /*横条的高度*/
    pointer-events: none;
  }
  /*拖动块的样式*/
  .range::-webkit-slider-thumb {
    position: relative;
    z-index: 2;
    -webkit-appearance: none; /*清除系统默认样式*/
    height: 22px; /*拖动块高度*/
    width: 22px; /*拖动块宽度*/
    background: #008acf; /*拖动块背景*/
    border-radius: 50%; /*外观设置为圆形*/
    border: 8px solid #ffffff; /*设置边框*/
    box-shadow: 0 0 0 6px hsla(0, 0%, 100%, 0.5);
    pointer-events: auto;
  }
  .video-duration {
    padding-right: 10px;
    color: #ffffff;
    text-align: left;
  }
  .video-currentTime {
    width: 90px;
    color: #ffffff;
    text-align: right;
  }
  .rate {
    height: 32px;
    width: 64px;
    line-height: 32px;
    text-align: center;
    border: 1px solid #fff;
    border-radius: 16px;
    margin: 0 25px;
    font-size: 16px;
    color: #fff;
  }
  .vp-tap {
    width: 30px;
    height: 26px;
    margin-right: 27px;
  }
  .screenshots {
    width: 30px;
    height: auto;
    margin-right: 27px;
  }
}
.fade-enter-active {
  animation: fade 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.fade-leave-active {
  animation: fade 0.3s reverse cubic-bezier(0.645, 0.045, 0.355, 1);
}
.tk-enter-active {
  animation: answer-in 0.5s cubic-bezier(0.745, 0, 0.31, 0.995);
}
.tk-leave-active {
  animation: answer-out 0.5s cubic-bezier(0.745, 0, 0.31, 0.995);
}
.xz-enter-active {
  animation: answer-in 0.5s cubic-bezier(0.745, 0, 0.31, 0.995);
}
.xz-leave-active {
  animation: answer-out 0s 0.5s cubic-bezier(0.745, 0, 0.31, 0.995);
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/playback/playback.vue